import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import LocalGame from './modes/LocalGame';
import heroImage from './game_of_the_generals.png';

const OnlineGame = React.lazy(() => import('./modes/OnlineGame'));

function App() {
  const [mode, setMode] = React.useState(null);

  if (mode === "local") return <LocalGame onBack={() => setMode(null)} />;
  if (mode === "online") return (
    <React.Suspense fallback={<div className="home"><p>Loading...</p></div>}>
      <OnlineGame onBack={() => setMode(null)} />
    </React.Suspense>
  );

  return (
    <div className="home">
      <img src={heroImage} alt="Game of the Generals" className="home-hero" />
      <h1 className="home-title">Game of the Generals</h1>
      <div className="home-buttons">
        <button className="home-btn" onClick={() => setMode("local")}>Local Play</button>
        <button className="home-btn home-btn-online" onClick={() => setMode("online")}>Play Online</button>
      </div>
    </div>
  );
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
